import { Member } from '@nextforce/api'
import { makeStyles } from '@rneui/themed'
import { MemberCard } from 'chat/members/views/card'
import { MembersList } from 'chat/members/views/list'
import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

interface Props {
  members: Member[]
  selectedMemberIds: string[]
  onSelectMember(id: string): void
}

export function MentionsView({
  members,
  onSelectMember,
  selectedMemberIds,
}: Props) {
  const styles = useStyles()

  if (!members) {
    return null
  }

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <MembersList
          members={members ?? []}
          renderItem={({ item: member }) => (
            <MemberCard
              member={member}
              selectable
              checked={selectedMemberIds.includes(member.id)}
              onPress={() => onSelectMember(member.id)}
            />
          )}
        />
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    padding: 10,
  },
  emptyContainer: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
